import { decomposeColor } from "@material-ui/core/styles/colorManipulator";

export default (color: string, alpha: number) => {
  const rgb: [number, number, number, number?] = decomposeColor(color).values;
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
};
